import { render, staticRenderFns } from "./writing.vue?vue&type=template&id=0fcb35c8&scoped=true"
import script from "./writing.vue?vue&type=script&lang=js"
export * from "./writing.vue?vue&type=script&lang=js"
import style0 from "./writing.vue?vue&type=style&index=0&id=0fcb35c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcb35c8",
  null
  
)

export default component.exports